import { Box, BoxProps, useTheme } from '@mui/material'
import { Aurora, AuroraAwhpData, AuroraAwhpEvent, Sensor } from '../types'
import AuroraStackCard from './AuroraStackCard'

export interface AuroraBlockDisplayProps extends Omit<BoxProps, 'children'> {
  aurora: Aurora
  auroraAwhpData?: AuroraAwhpData | null
  auroraAwhpActiveEvents?: AuroraAwhpEvent[]
  sensor?: Sensor | null
}

export default function AuroraBlockDisplay({
  aurora,
  auroraAwhpData,
  auroraAwhpActiveEvents,
  sensor,
  sx,
  ...props
}: AuroraBlockDisplayProps) {
  const theme = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: theme.palette.background.default,
        borderRadius: 1,
        p: 6,
        ...sx
      }}
      {...props}
    >
      <AuroraStackCard
        aurora={aurora}
        auroraAwhpData={auroraAwhpData}
        auroraAwhpActiveEvents={auroraAwhpActiveEvents}
        sensor={sensor}
      />
    </Box>
  )
}
